'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _themeProductForm = require('@shopify/theme-product-form');

var _themeSections = require('@shopify/theme-sections');

var _utils = require('../utils');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var className = 'js-Product';
var classes = {
  fixedBar: '.' + className + '_FixedBar',
  form: '.' + className + '_Form',
  imageItem: '.' + className + '_ImageItem',
  priceWrapper: '.' + className + '_PriceWrapper',
  price: '.' + className + '_Price',
  priceCompare: '.' + className + '_PriceCompare',
  priceCompareText: '.' + className + '_PriceCompareText',
  quantity: '.' + className + '_Quantity',
  select: '.' + className + '_Select',
  singleOptionSelect: '.' + className + '_SingleOptionSelect',
  sku: '.' + className + '_Sku',
  submit: '.' + className + '_Submit',
  submitText: '.' + className + '_SubmitText',
  bisButton: '.' + className + '_BackInStock'
};

(0, _themeSections.register)('product', {
  onLoad: function onLoad() {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var forms, productFormData;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              forms = (0, _functional.getElements)(classes.form);
              _context2.next = 3;
              return _promise2.default.all(forms.map(function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(el) {
                  var handle, productData;
                  return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          handle = el.dataset.productHandle;
                          _context.next = 3;
                          return (0, _functional.fetchProductData)(handle);

                        case 3:
                          productData = _context.sent;
                          return _context.abrupt('return', {
                            el: el,
                            data: productData
                          });

                        case 5:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));

            case 3:
              productFormData = _context2.sent;

              _this.productDetail = new ProductDetail(productFormData);

              _this.setupFixedBar();

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  onUnload: function onUnload() {
    this.productDetail.destroyProductForms();
  },
  setupFixedBar: function setupFixedBar() {
    // eslint-disable-next-line no-new
    new FixedBar();
  }
});

function ProductDetail(productFormData) {
  this.onOptionChange = this.onOptionChange.bind(this);
  this.onQuantityChange = this.onQuantityChange.bind(this);

  this.productForms = this.setupProductForms(productFormData);
  this.productJSON = productFormData[0].data;
}

ProductDetail.prototype.setupProductForms = function setupProductForms(productFormData) {
  var _this2 = this;

  return productFormData.map(function (productData) {
    var productForm = new _themeProductForm.ProductForm(productData.el, productData.data, {
      onOptionChange: _this2.onOptionChange,
      onQuantityChange: _this2.onQuantityChange
    });

    return _this2.patchProductForm(productForm);
  });
};

ProductDetail.prototype.destroyProductForms = function destroyProductForms() {
  return this.productForms.map(function (productForm) {
    return productForm.destroy();
  });
};

ProductDetail.prototype.onOptionChange = function onOptionChange(event) {
  var variant = event.dataset.variant;

  var bisButton = (0, _functional.getElement)(classes.bisButton);

  if (bisButton == null) return;

  this.syncFormElements(event);

  if (variant === null) {
    this.resetPage();
    bisButton.classList.add('prd-DetailForm_Link-backInStockHidden');

    return;
  }

  this.setVariantUrl(variant);
  this.setVariantPrice(variant);
  this.setVariantSku(variant);
  this.setVariantImage(variant);
  this.setVariantAvailability(variant);
};

ProductDetail.prototype.syncFormElements = function syncFormElements(event) {
  var value = event.target.value;
  var wantedClass = [].concat((0, _toConsumableArray3.default)(event.target.classList)).find(function (_class) {
    return _class.includes('' + className);
  });

  this.productForms.forEach(function (productForm) {
    var select = (0, _functional.getElement)('.' + wantedClass, { context: productForm.element });

    select.value = value;
  });
};

ProductDetail.prototype.resetPage = function resetPage() {
  this.setVariantPrice(this.productJSON.variants[0]);
  this.updateUrl(window.location.pathname);
  this.setVariantAvailability();
};

ProductDetail.prototype.setVariantUrl = function setVariantUrl(variant) {
  this.updateUrl((0, _themeProductForm.getUrlWithVariant)(window.location.href, variant.id));
};

ProductDetail.prototype.setVariantPrice = function setVariantPrice(variant) {
  this.unhidePriceEls();

  var priceElements = (0, _functional.getElements)(classes.price);
  priceElements.forEach(function (el) {
    return el.innerHTML = (0, _functional.formatMoney)(variant.price);
  });

  var priceCompareElements = (0, _functional.getElements)(classes.priceCompare);
  priceCompareElements.forEach(function (el) {
    return el.innerHTML = (0, _functional.formatMoney)(variant.compare_at_price);
  });

  if (!variant.compare_at_price) {
    this.hidePriceCompareElements();
  }
};

ProductDetail.prototype.setVariantSku = function setVariantSku(variant) {
  (0, _functional.getElements)(classes.sku).forEach(function (el) {
    return el.textContent = variant.sku;
  });
};

ProductDetail.prototype.setVariantImage = function setVariantImage(variant) {
  if (!variant.featured_image) return;

  if (window.innerWidth < _utils.mediaBreakpoints.sm) {
    var imageId = variant.featured_image.id;

    if (window.theme.productCarousel) {
      window.theme.productCarousel.slideTo([].concat((0, _toConsumableArray3.default)(window.theme.productCarousel.slides)).findIndex(function (slide) {
        return slide.dataset.productImage === '' + imageId;
      }));
    }
  }
};

ProductDetail.prototype.setVariantAvailability = function setVariantAvailability(variant) {
  var hasVariant = !!variant;
  var variantIsAvailable = variant && variant.available;
  var submitEls = (0, _functional.getElements)(classes.submit);
  var submitTextEls = (0, _functional.getElements)(classes.submitText);
  var bisButton = (0, _functional.getElement)(classes.bisButton);

  if (variantIsAvailable) {
    bisButton.classList.add('prd-DetailForm_Link-backInStockHidden');
  } else {
    bisButton.classList.remove('prd-DetailForm_Link-backInStockHidden');
  }

  submitEls.forEach(function (submitButton) {
    submitButton.disabled = !variantIsAvailable;
  });
  submitTextEls.forEach(function (submitText) {
    submitText.textContent = !hasVariant ? window.theme.strings.pleaseChoose : variantIsAvailable ? window.theme.strings.addToCart : window.theme.strings.soldOut;
  });
};

ProductDetail.prototype.updateUrl = function updateUrl(url) {
  window.history.replaceState({ path: url }, '', url);
};

ProductDetail.prototype.hideElements = function hideElements(elements) {
  elements.forEach(function (el) {
    return el.hidden = true;
  });
};

ProductDetail.prototype.unhideElements = function unhideElements(elements) {
  elements.forEach(function (el) {
    return el.hidden = false;
  });
};

ProductDetail.prototype.unhidePriceEls = function unhidePriceEls() {
  this.unhideElements((0, _functional.getElements)(classes.price + ', ' + classes.priceCompare));
};

ProductDetail.prototype.hidePriceCompareElements = function hidePriceCompareElements() {
  this.hideElements((0, _functional.getElements)(classes.priceCompare));
};

ProductDetail.prototype.patchProductForm = function patchProductForm(productForm) {
  if (productForm.options().length === 0) {
    var submitListener = productForm._listeners.entries.find(function (listener) {
      return listener.event === 'submit';
    });
    submitListener.element.removeEventListener(submitListener.event, submitListener.fn);

    productForm._listeners.entries = productForm._listeners.entries.filter(function (entry) {
      return entry.event !== 'submit';
    });
  }

  return productForm;
};

ProductDetail.prototype.onQuantityChange = function onQuantityChange(event) {
  this.syncFormElements(event);
};

var FixedBar = function () {
  function FixedBar() {
    (0, _classCallCheck3.default)(this, FixedBar);

    this.fixedBarThreshold = 100;
    this.el = (0, _functional.getElement)(classes.fixedBar);
    this.header = (0, _functional.getElement)('.hd-Header');

    this.isTicking = false;
    // eslint-disable-next-line compat/compat
    this.lastKnownY = window.scrollY;

    this._isFixed = this.lastKnownY > this.fixedBarThreshold;

    this.onScroll = this.onScroll.bind(this);
    this.updateEl = this.updateEl.bind(this);

    this.setupListeners();
  }

  (0, _createClass3.default)(FixedBar, [{
    key: 'setupListeners',
    value: function setupListeners() {
      window.addEventListener('scroll', this.onScroll);
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      // eslint-disable-next-line compat/compat
      this.lastKnownY = window.scrollY || window.pageYOffset;

      this.requestTick();
    }
  }, {
    key: 'requestTick',
    value: function requestTick() {
      if (!this.isTicking) window.requestAnimationFrame(this.updateEl);

      this.isTicking = true;
    }
  }, {
    key: 'updateEl',
    value: function updateEl() {
      this.isTicking = false;

      this.isFixed = this.lastKnownY >= this.fixedBarThreshold;
    }
  }, {
    key: 'isFixed',
    get: function get() {
      return this._isFixed;
    },
    set: function set(val) {
      this._isFixed = val;

      this.el.classList.toggle('prd-FixedBar-active', val);
      this.header.classList.toggle('hd-Header-visible', !val);
    }
  }]);
  return FixedBar;
}();